import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { BrowserRouter as Router } from "react-router-dom";
import { Provider } from "react-redux";
import reportWebVitals from "./reportWebVitals";
import Store from "./Store";
import LayoutProvider from "./context/LayoutProvider";
import SocketProvider from "./redux/hook/socket/SocketProvider";

ReactDOM.render(
  <React.StrictMode>
    <Provider store={Store}>
      <SocketProvider>
        <LayoutProvider>
          <Router>
            <App />
          </Router>
        </LayoutProvider>
      </SocketProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
